import React, { useState, useEffect, Fragment } from "react";
import { CSVLink } from "react-csv";
import { connect } from "react-redux";

import MakeAPICall from "../../apiCalls/common";

import {
  getConstansApiRoute,
  updateConstantsApiRoute,
  getConsultDetailsMedicareApiRoute,
  addConsultDetailMedicareApiRoute,
  editConsultDetailMedicareApiRoute,
  deleteConsultDetailMedicareApiRoute,
  changeConsultDetailsMedicareSequenceApiRoute,
  uploadCovidHotSpotDataApiRoute,
  addICMBSItemApiRoute,
  editICMBSItemApiRoute,
  deleteICMBSItemApiRoute
} from "../../apiRoutes";

import { sortData } from "../../utils/commonMethods";

import Loader from "../../components/loader";
import CustomModal from "../../components/modal";
import CustomDataTable from "../../components/datatable/customDataTable";
import Button from "../../components/button";

import ConsultCostMedicareForm from "../../containers/ConsultCost/consultCostMedicareForm";
import ConsultGstForm from "../../containers/ConsultCost/consultGstForm";
import ConsultPmFeeForm from "../../containers/ConsultCost/consultPmFeeForm";
import EditCostSequence from "../../containers/ConsultCost/editCostSequence";
import UploadCovidHotSportDataForm from "../../containers/UploadCovidHotSpotData";

const ConsultCostMedicarePage = props => {
  const [isProcessing, setIsProcessing] = useState(false);
  const [apiCallParams, setApiCallParams] = useState(null);
  const [apiCallParams1, setApiCallParams1] = useState(null);
  const [serverConstants, setServerConstants] = useState(null);
  const [consultsCostList, setConsultsCostList] = useState([]);
  const [filteredConsultsCostList, setFilteredConsultsCostList] = useState([]);
  const [excelSheetData, setExcelSheetData] = useState([]);
  const [selConsult, setSelConsult] = useState(null);
  const [totalRecords, setTotalRecords] = useState(0);
  const [currFilters, setCurrFilters] = useState({
    skip: 0,
    limit: 10
  });
  const [showTextModal, setShowTextModal] = useState(false);
  const [modalText, setModalText] = useState("");

  const [consultFormModalTitle, setConsultFormModalTitle] = useState("");
  const [showConsultFormModal, setShowConsultFormModal] = useState(false);
  const [showDelModal, setShowDelModal] = useState(false);
  const [showGstModal, setShowGstModal] = useState(false);
  const [showPmFeeModal, setShowPmFeeModal] = useState(false);
  const [showEditSeqModal, setShowEditSeqModal] = useState(false);
  const [showCovidCSVModal, setShowCovidCSVModal] = useState(false);
  const [showICItemModal, setShowICItemModal] = useState(false);
  const [icItemModalTitle, setICItemModalTitle] = useState("");
  const [icMBSItemsList, setIcMBSItemsList] = useState([]);
  const [filteredIcMBSItemsList, setFilteredIcMBSItemsList] = useState([]);
  const [selectedIcMBSItem, setSelectedIcMBSItem] = useState(null);
  const [showIcMBSDelModal, setShowIcMBSDelModal] = useState(false);

  let excelSheetHeader = [
    {
      label: "Sequence Number",
      key: "Sequence_Number"
    },
    {
      label: "MBS Item No",
      key: "mbsItemNo"
    },
    {
      label: "Consult_Cost",
      key: "Consult_Cost"
    },
    {
      label: "Consult Duration",
      key: "Consult_Duration"
    },
    {
      label: "Consult Description",
      key: "Consult_Description"
    }
  ];

  let tableHeaders = [
    {
      key: "id",
      value: "Sr No."
    },
    {
      key: "mbsItemNo",
      value: "MBS Item No"
    },
    {
      key: "price",
      value: "Bulk-Billed Fee ($)"
    },
    {
      key: "content",
      value: "Consult Duration"
    },
    {
      key: "description",
      value: "Consult Description"
    }
  ];

  let instantConsultTableHeaders = [
    {
      key: "id",
      value: "Sr No."
    },
    {
      key: "mbsItemNo",
      value: "MBS Item No"
    },
    {
      key: "price",
      value: "Bulk-Billed Fee ($)"
    },
    {
      key: "description",
      value: "Consult Description"
    },
    {
      key: "Action",
      value: "Action"
    }
  ];

  if (props.user.userType === "SUPER_ADMIN") {
    tableHeaders.push.apply(tableHeaders, [{ key: "Action", value: "Action" }]);
  }

  // create custom table filter function
  const customSearchTableByText = query => {
    let newList = consultsCostList.filter(item => {
      if (item.id === parseInt(query)) {
        return true;
      } else if (item.content.toLowerCase().includes(query.toLowerCase())) {
        return true;
      } else if (item.description.toLowerCase().includes(query.toLowerCase())) {
        return true;
      } else if (
        item.consultPrice
          .toString()
          .toLowerCase()
          .includes(query.toLowerCase())
      ) {
        return true;
      } else if (
        item.mbsItemNo
          .toString()
          .toLowerCase()
          .includes(query.toLowerCase())
      ) {
        return true;
      }
      return false;
    });

    setFilteredConsultsCostList(newList);
  };

  const setTableFilters = filters => {
    if (filters.text && filters.text.length > 0) {
      customSearchTableByText(filters.text);
    } else {
      let newFilter = Object.assign({}, currFilters);
      newFilter.limit = filters.limit;
      newFilter.skip = filters.skip;

      setCurrFilters(newFilter);
    }
  };

  const sortTableDataByColumn = SelColumn => {
    let sortedData = sortData(
      SelColumn.column,
      SelColumn.order,
      filteredConsultsCostList
    );
    setFilteredConsultsCostList(sortedData);
  };

  // handle all data table pagination at frontend
  const filterConsultList = list => {
    let newList = [];
    if (list) {
      newList = list.slice(
        currFilters.skip,
        currFilters.skip + currFilters.limit
      );
    } else {
      newList = consultsCostList.slice(
        currFilters.skip,
        currFilters.skip + currFilters.limit
      );
    }

    setFilteredConsultsCostList(newList);
  };

  // get constants
  const getServerConstants = () => {
    setApiCallParams1({
      reqType: "GET",
      reqUrl: getConstansApiRoute,
      successCallback: res => {
        setServerConstants(res.data.data);
        
        // Populate IC MBS Items from constants
        if (res.data.data.icMBSItemIncentives && Array.isArray(res.data.data.icMBSItemIncentives)) {
          let list = [];
          res.data.data.icMBSItemIncentives.forEach((item, index) => {
            let d = {};
            d._id = item._id;
            d.id = index + 1;
            d.mbsItemNo = item.mbsItemNo;
            d.price = item.amount;
            d.consultPrice = parseFloat(item.amount).toFixed(2);
            d.description = item.description;
            d.feeNote = item.feeNote;
            d.sequence = item.sequence;
            list.push(d);
          });
          setIcMBSItemsList(list);
          setFilteredIcMBSItemsList(list);
        } else {
          // Initialize empty arrays if icMBSItemIncentives doesn't exist yet
          setIcMBSItemsList([]);
          setFilteredIcMBSItemsList([]);
        }
      },
      failureCallback: err => {
        setIsProcessing(false);
        // setModalText(
        //   "Please try again. Please contact Instant Consult Support on 1300 003 310 if this issue persists."
        // );
        // setShowTextModal(true);
      }
    });
  };

  // update server constants
  const updateServerConstants = (formData, formType) => {
    setShowPmFeeModal(false);
    setShowGstModal(false);
    setIsProcessing(true);

    if(formData.get("PMFee")) {
      let fee = formData.get("PMFee");
      formData.delete("PMFee");
      formData.append("MedicarePMFee", fee);
    }

    setApiCallParams1({
      reqType: "PUT",
      reqUrl: updateConstantsApiRoute,
      dataObj: formData,
      successCallback: res => {
        setIsProcessing(false);
        if (formType === "PMF") {
          setModalText("Practice Management Fee Updated Successfully");
        } else {
          setModalText("GST on Practice Management Fee Updated Successfully");
        }
        setShowTextModal(true);
        getServerConstants();
      },
      failureCallback: err => {
        setIsProcessing(false);
        // setModalText(
        //   "Please try again. Please contact Instant Consult Support on 1300 003 310 if this issue persists."
        // );
        // setShowTextModal(true);
      }
    });
  };

  // get nature of consults
  const getConsults = () => {
    setIsProcessing(true);

    setApiCallParams({
      reqType: "GET",
      reqUrl: getConsultDetailsMedicareApiRoute,
      params: {
        skip: 0,
        limit: 0
      },
      successCallback: async res => {
        let list = [];
        let excelList = [];
        await res.data.data.consultDetailData.forEach((column, index) => {
          let d = {};
          let e = {};

          d._id = column._id;
          d.id = index + 1;
          d.content =
            column.consultMode + " " + column.consultDuration + " Mins";
          d.consultPrice = parseFloat(column.consultPrice).toFixed(2);
          d.price = column.consultPrice;
          if (column.description) {
            d.description = column.description;
          } else {
            d.description = " ";
          }
          d.consultDuration = column.consultDuration;
          d.consultMode = column.consultMode;
          d.mbsItemNo = column.mbsItemNo;
          d.incentiveGroup = column.incentiveGroup;

          e.Sequence_Number = index + 1;
          e.mbsItemNo = column.mbsItemNo;
          e.Consult_Cost = column.consultPrice;
          e.Consult_Duration =
            column.consultMode + " " + column.consultDuration + " Mins";
          if (column.description) {
            e.Consult_Description = column.description;
          } else {
            e.Consult_Description = " ";
          }

          list.push(d);
          excelList.push(e);
        });
        setConsultsCostList(list);
        setTotalRecords(res.data.data.totalCount);
        setExcelSheetData(excelList);
        filterConsultList(list);
        setIsProcessing(false);
      },
      failureCallback: err => {
        setIsProcessing(false);
        // setModalText(
        //   "Please try again. Please contact Instant Consult Support on 1300 003 310 if this issue persists."
        // );
        // setShowTextModal(true);
      }
    });
  };

  // delete consult
  const delSelConsult = () => {
    setShowDelModal(false);
    setIsProcessing(true);

    let parm = {
      consultDetailId: selConsult._id
    };

    setApiCallParams({
      reqType: "DELETE",
      reqUrl: deleteConsultDetailMedicareApiRoute,
      params: parm,
      successCallback: res => {
        setIsProcessing(false);
        setModalText("Medicare Benefits Schedule Deleted Successfully.");
        setShowTextModal(true);
        getConsults();
      },
      failureCallback: err => {
        setIsProcessing(false);
        // setModalText(
        //   "Please try again. Please contact Instant Consult Support on 1300 003 310 if this issue persists."
        // );
        // setShowTextModal(true);
      }
    });
  };

  // add new consult
  const addNewConsult = values => {
    setShowConsultFormModal(false);
    setIsProcessing(true);

    setApiCallParams({
      reqType: "POST",
      reqUrl: addConsultDetailMedicareApiRoute,
      dataObj: values,
      successCallback: res => {
        setIsProcessing(false);
        setModalText("Medicare Benefits Schedule Added Successfully.");
        setShowTextModal(true);
        getConsults();
      },
      failureCallback: err => {
        setIsProcessing(false);
        // setModalText(
        //   "Please try again. Please contact Instant Consult Support on 1300 003 310 if this issue persists."
        // );
        // setShowTextModal(true);
      }
    });
  };

  // edit consult
  const editSelConsult = values => {
    setShowConsultFormModal(false);
    setSelConsult(null);
    setIsProcessing(true);

    setApiCallParams({
      reqType: "PUT",
      reqUrl: editConsultDetailMedicareApiRoute,
      dataObj: values,
      successCallback: res => {
        setIsProcessing(false);
        setModalText("Medicare Benefits Schedule Updated Successfully.");
        setShowTextModal(true);
        getConsults();
      },
      failureCallback: err => {
        setIsProcessing(false);
        // setModalText(
        //   "Please try again. Please contact Instant Consult Support on 1300 003 310 if this issue persists."
        // );
        // setShowTextModal(true);
      }
    });
  };

  // update consult sequence
  const updateConsultSequence = newSeq => {
    setShowEditSeqModal(false);
    setIsProcessing(true);

    var array = [];
    for (var x = 0; x < newSeq.length; x++) {
      array.push({
          consultId: newSeq[x]._id,
          seqNo: x
      });
    }

    const dataToSend = {
      sequence: array
    }

    setApiCallParams({
      reqType: "PUT",
      reqUrl: changeConsultDetailsMedicareSequenceApiRoute,
      dataObj: dataToSend,
      successCallback: res => {
        setIsProcessing(false);
        setModalText("Sequence Changed Successfully");
        setShowTextModal(true);
        getConsults();
      },
      failureCallback: err => {
        setIsProcessing(false);
        // setModalText(
        //   "Please try again. Please contact Instant Consult Support on 1300 003 310 if this issue persists."
        // );
        // setShowTextModal(true);
      }
    });
  };

  const toggleCovidCSVModal = () => {
    setShowCovidCSVModal(!showCovidCSVModal);
  };

  // upload Covid-19 hotspot data
  const uploadCovidHotSpotData = file => {
    toggleCovidCSVModal();
    setIsProcessing(true);

    let formData = new FormData();
    formData.append("csvFile", file);

    setApiCallParams({
      reqType: "POST",
      reqUrl: uploadCovidHotSpotDataApiRoute,
      dataObj: formData,
      successCallback: res => {
        setIsProcessing(false);

        setModalText("Data Uploaded Successfully");
        setShowTextModal(true);
      },
      failureCallback: err => {
        setIsProcessing(false);
        // setModalText(
        //   "Please try again. Please contact Instant Consult Support on 1300 003 310 if this issue persists."
        // );
        // setShowTextModal(true);
      }
    });
  };

  useEffect(() => {
    if (consultsCostList.length === 0) {
      getConsults();
    }

    if (serverConstants === null) {
      getServerConstants();
    }


    filterConsultList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currFilters]);

  const showSelUpdateModal = item => {
    setSelConsult(item);
    setConsultFormModalTitle("Edit Medicare Benefits Schedule");
    setShowConsultFormModal(true);
  };

  const showConsultAddModal = () => {
    setConsultFormModalTitle("Add Medicare Benefits Schedule");
    setShowConsultFormModal(true);
  };

  const showSelDelModal = item => {
    setSelConsult(item);
    setShowDelModal(true);
  };

  const togglePmFeeModal = () => {
    setShowPmFeeModal(!showPmFeeModal);
  };

  const toggleGstModal = () => {
    setShowGstModal(!showGstModal);
  };

  const showICItemAddModal = () => {
    setICItemModalTitle("Add MBS Item");
    setSelectedIcMBSItem(null);
    setShowICItemModal(true);
  };

  const showICItemEditModal = (item) => {
    setSelectedIcMBSItem(item);
    setICItemModalTitle("Edit MBS Item");
    setShowICItemModal(true);
  };

  const showICItemDelModal = (item) => {
    setSelectedIcMBSItem(item);
    setShowIcMBSDelModal(true);
  };

  // add new IC MBS item
  const addNewIcMBSItem = values => {
    setShowICItemModal(false);
    setIsProcessing(true);

    let formData = new FormData();
    formData.append("mbsItemNo", values.get("mbsItemNo"));
    formData.append("amount", values.get("consultPrice"));
    formData.append("description", values.get("description"));
    formData.append("sequence", icMBSItemsList.length + 1);
    formData.append("feeNote", values.get("feeNote"));

    setApiCallParams({
      reqType: "POST",
      reqUrl: addICMBSItemApiRoute,
      dataObj: formData,
      successCallback: res => {
        setIsProcessing(false);
        setModalText("Item Added Successfully.");
        setShowTextModal(true);
        getServerConstants(); // Refresh constants to get updated IC MBS items
      },
      failureCallback: err => {
        setIsProcessing(false);
        // Error is automatically displayed by MakeAPICall component
      }
    });
  };

  // edit IC MBS item
  const editIcMBSItem = values => {
    setShowICItemModal(false);
    setIsProcessing(true);

    let formData = new FormData();
    formData.append("icMBSItemIncentiveId", selectedIcMBSItem._id);
    formData.append("mbsItemNo", values.get("mbsItemNo"));
    formData.append("amount", values.get("consultPrice"));
    formData.append("description", values.get("description"));
    formData.append("sequence", selectedIcMBSItem.sequence);
    formData.append("feeNote", values.get("feeNote"));

    setApiCallParams({
      reqType: "POST",
      reqUrl: editICMBSItemApiRoute,
      dataObj: formData,
      successCallback: res => {
        setIsProcessing(false);
        setModalText("Item Updated Successfully.");
        setShowTextModal(true);
        getServerConstants(); // Refresh constants to get updated IC MBS items
        setSelectedIcMBSItem(null);
      },
      failureCallback: err => {
        setIsProcessing(false);
        // Error is automatically displayed by MakeAPICall component
      }
    });
  };

  // delete IC MBS item
  const deleteIcMBSItem = () => {
    setShowIcMBSDelModal(false);
    setIsProcessing(true);

    let formData = new FormData();
    formData.append("icMBSItemIncentiveId", selectedIcMBSItem._id);

    setApiCallParams({
      reqType: "POST",
      reqUrl: deleteICMBSItemApiRoute,
      dataObj: formData,
      successCallback: res => {
        setIsProcessing(false);
        setModalText("Item Deleted Successfully.");
        setShowTextModal(true);
        getServerConstants(); // Refresh constants to get updated IC MBS items
        setSelectedIcMBSItem(null);
      },
      failureCallback: err => {
        setIsProcessing(false);
      }
    });
  };

  // Generate dynamic bottom content based on IC MBS Items
  const generateBottomContent = () => {
    if (!serverConstants || !serverConstants.icMBSItemIncentives || serverConstants.icMBSItemIncentives.length === 0) {
      return "";
    }

    let content = [];

    // Process each item individually
    serverConstants.icMBSItemIncentives.forEach(item => {
      const amount = `$${parseFloat(item.amount).toFixed(2)}`;
      const itemNo = `Item No ${item.mbsItemNo}`;
      const description = item.description || "";
      const line = `${item.feeNote}Additional ${amount} ${description} (${itemNo})`;
      content.push(line);
    });

    return content.join(" <br/>");
  };

  return (
    <div className="view-ticket-container consult-nature-page-container">
      <CustomModal
        useOneButton={true}
        cancelText="OKAY"
        openModal={showTextModal}
        cancelEvent={() => {
          setShowTextModal(false);
          setModalText("");
        }}
        modalBodyContent={<p className="text-center mb-0">{modalText}</p>}
      />
      <CustomModal
        openModal={showEditSeqModal}
        cancelEvent={() => {
          setShowEditSeqModal(false);
        }}
        title="Edit Sequence"
        modalBodyContent={
          <EditCostSequence
            consults={consultsCostList}
            onUpdate={updateConsultSequence}
          />
        }
        noFooterButtons={true}
      />
      <CustomModal
        className="modal-lg"
        openModal={showGstModal}
        cancelEvent={toggleGstModal}
        title="GST on Practice Management Fee (%)"
        modalBodyContent={
          <ConsultGstForm
            gst={
              serverConstants ? serverConstants.tax.toFixed(2).toString() : ""
            }
            onUpdateFormSubmit={updateServerConstants}
          />
        }
        noFooterButtons={true}
      />
      <CustomModal
        className="modal-lg"
        openModal={showPmFeeModal}
        cancelEvent={togglePmFeeModal}
        title="Practice Management Fee ($)"
        modalBodyContent={
          <ConsultPmFeeForm
            fee={
              serverConstants && serverConstants.MedicarePMFee ? serverConstants.MedicarePMFee.toFixed(2).toString() : ""
            }
            onUpdateFormSubmit={updateServerConstants}
          />
        }
        noFooterButtons={true}
      />
      <CustomModal
        className="modal-lg"
        openModal={showConsultFormModal}
        cancelEvent={() => {
          setShowConsultFormModal(false);
          setSelConsult(null);
        }}
        title={consultFormModalTitle}
        modalBodyContent={
          <ConsultCostMedicareForm
            consult={selConsult}
            onAddSubmit={addNewConsult}
            onEditSubmit={editSelConsult}
          />
        }
        noFooterButtons={true}
      />
      <CustomModal
        okayText="Yes"
        cancelText="No"
        openModal={showDelModal}
        cancelEvent={() => {
          setShowDelModal(false);
          setSelConsult(null);
        }}
        okayEvent={delSelConsult}
        modalBodyContent={
          <p className="text-center mb-0">
            Are you sure you want to delete this consult cost?
          </p>
        }
      />
      <CustomModal
        openModal={showCovidCSVModal}
        cancelEvent={toggleCovidCSVModal}
        title="Upload COVID-19 Hot Spots CSV"
        modalBodyContent={
          <UploadCovidHotSportDataForm onSheetSubmit={uploadCovidHotSpotData} />
        }
        noFooterButtons={true}
      />
      <CustomModal
        className="modal-lg"
        openModal={showICItemModal}
        cancelEvent={() => {
          setShowICItemModal(false);
        }}
        title={icItemModalTitle}
        modalBodyContent={
          <ConsultCostMedicareForm
            consult={selectedIcMBSItem}
            onAddSubmit={addNewIcMBSItem}
            onEditSubmit={editIcMBSItem}
            hideConsultDuration={true}
          />
        }
        noFooterButtons={true}
      />
      <CustomModal
        okayText="Yes"
        cancelText="No"
        openModal={showIcMBSDelModal}
        cancelEvent={() => {
          setShowIcMBSDelModal(false);
          setSelectedIcMBSItem(null);
        }}
        okayEvent={deleteIcMBSItem}
        modalBodyContent={
          <p className="text-center mb-0">
            Are you sure you want to delete this MBS item?
          </p>
        }
      />
      {isProcessing && <Loader />}
      <div className={isProcessing ? "disableContainer" : ""}>
        <div className="d-flex flex-row justify-content-between">
          <div>
            <h3>Medicare Benefits Schedule</h3>
            <p>
              Criteria: patients under 12 months of age
              {/* <br />or living in a COVID-19 impacted area */}
            </p>
          </div>
          {props.user && props.user.userType === "SUPER_ADMIN" && (
            <div className="d-flex flex-column align-items-end">
              <div className="d-flex flex-row align-items-end mb-4">
                <Button
                  className="ic-btn-grey"
                  clickEvent={togglePmFeeModal}
                  title="Practice Management Fee ($)"
                ></Button>
                &nbsp;&nbsp;&nbsp;&nbsp;
                <Button
                  className="ic-btn-grey"
                  clickEvent={toggleGstModal}
                  title="GST on Practice Management Fee (%)"
                ></Button>
              </div>
              <div className="d-flex flex-row align-items-end">
                <Fragment>
                  <Button
                    clickEvent={toggleCovidCSVModal}
                    title="Upload COVID-19 CSV"
                  ></Button>
                  &nbsp;&nbsp;&nbsp;&nbsp;
                </Fragment>
                <Button
                  clickEvent={() => {
                    setShowEditSeqModal(true);
                  }}
                  title="Edit Sequence"
                ></Button>
                &nbsp;&nbsp;&nbsp;&nbsp;
                <Button
                  clickEvent={showConsultAddModal}
                  title="Add MBS"
                ></Button>
                &nbsp;&nbsp;&nbsp;&nbsp;
                <CSVLink
                  className="no-text-decoration"
                  filename={"Consult Costs.csv"}
                  data={excelSheetData}
                  headers={excelSheetHeader}
                >
                  <Button title="Export to CSV"></Button>
                </CSVLink>
              </div>
            </div>
          )}
        </div>
        <CustomDataTable
          totalRecords={totalRecords}
          headers={tableHeaders}
          setFilters={setTableFilters}
          sortData={sortTableDataByColumn}
          tabFilters={currFilters}
          bottomContent={generateBottomContent()}
        >
          {filteredConsultsCostList.map((item, index) => (
            <tr key={index}>
              <td>{item.id}</td>
              <td>{item.mbsItemNo}</td>
              <td>$&nbsp;{item.consultPrice} {item.incentiveGroup || '*'}</td>
              <td>{item.content}</td>
              <td>{item.description}</td>
              {props.user && props.user.userType === "SUPER_ADMIN" && (
                <td>
                  <button
                    type="button"
                    className="btn btn-out-bell high-z-index ml-2"
                    onClick={() => showSelUpdateModal(item)}
                  >
                    <i className="fas fa-edit"></i>
                  </button>
                  <button
                    onClick={() => showSelDelModal(item)}
                    type="button"
                    className="btn btn-out-delete high-z-index ml-2"
                  >
                    <i className="fas fa-trash-alt"></i>
                  </button>
                </td>
              )}
            </tr>
          ))}
        </CustomDataTable>

        <div className="mt-5">
          <div className="d-flex flex-row justify-content-between">
            <div>
              <h3>MBS Item Incentives</h3>
            </div>
            {props.user && props.user.userType === "SUPER_ADMIN" && (
              <div className="d-flex flex-row align-items-end">
                <Button
                  clickEvent={showICItemAddModal}
                  title="Add Item"
                />
              </div>
            )}

          </div>
          <CustomDataTable
            totalRecords={filteredIcMBSItemsList.length}
            headers={instantConsultTableHeaders}
            setFilters={() => {}}
            sortData={() => {}}
            tabFilters={{ skip: 0, limit: 10 }}
          >
            {filteredIcMBSItemsList.map((item, index) => (
              <tr key={index}>
                <td>{item.id}</td>
                <td>{item.mbsItemNo}</td>
                <td>$&nbsp;{item.consultPrice} {item.feeNote}</td>
                <td>{item.description}</td>
                <td>
                  <button
                    type="button"
                    className="btn btn-out-bell high-z-index ml-2"
                    onClick={() => showICItemEditModal(item)}
                  >
                    <i className="fas fa-edit"></i>
                  </button>
                  <button
                    type="button"
                    className="btn btn-out-delete high-z-index ml-2"
                    onClick={() => showICItemDelModal(item)}
                  >
                    <i className="fas fa-trash-alt"></i>
                  </button>
                </td>
              </tr>
            ))}
          </CustomDataTable>
        </div>

        {/* API Call */}
        <MakeAPICall apiParam={apiCallParams} />
        <MakeAPICall apiParam={apiCallParams1} />
      </div>
    </div>
  );
};

const mapStateToProps = state => ({
  user: state.auth.user
});

export default connect(mapStateToProps, null)(ConsultCostMedicarePage);
